/**
 * The options of the cameras list: its tab and the settings of its ⋮ menu. The panel reads them
 * back from its local props, which are JSON, so they are frozen objects, not enums.
 */

/** The tabs of the Cameras panel. */
export const CamerasTab = Object.freeze({
    Cameras: 'cameras',
    Layouts: 'layouts',
} as const);
export type CamerasTab = typeof CamerasTab[keyof typeof CamerasTab];

/** What a plain click on a row does in the multi-camera mode. */
export const RowClick = Object.freeze({
    /** Shows only the camera, as a double-click does. The default. */
    Only: 'only',
    /** Checks or unchecks the camera, as its checkbox does. */
    Toggle: 'toggle',
} as const);
export type RowClick = typeof RowClick[keyof typeof RowClick];

/** The side of a row that shows its checkbox. */
export const CheckboxSide = Object.freeze({
    /** At the right edge, with the agent icons after the name. The default. */
    Right: 'right',
    /** In the place of the status mark, with the agent icons at the right edge. */
    Left: 'left',
} as const);
export type CheckboxSide = typeof CheckboxSide[keyof typeof CheckboxSide];
